import axios from 'axios'

const api = window.URL_API_TIMELINE

export const load = (id, start = 0) =>
    axios.get(`${api}timeline_comments/comments/${id}/${start}/5`)

export const loadAnswers = (id, start = 0) =>
    axios.get(`${api}timeline_comments/comments_answers/${id}/${start}/5`)


export const deleteComment = (id) =>
    axios.get(`${api}timeline_comments/delete_comment/${id}`)

export const createComment = (post_id, comment, reply_to = 0) =>
    axios.post(`${api}timeline_comments/new_comment/${post_id}`, { comment, reply_to })


// WEBPACK FOOTER //
// ./src/SPRINTA/utils/timeline_comments.js